import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import Fade from "react-reveal/Fade";
import TranslateButton from "../../TranslateButton/TranslateButton";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp } from "@fortawesome/free-solid-svg-icons";

const MissionAndVision = () => {
  useEffect(() => {
    document.title = `Development Concern | Mission and Vision`;
  }, []);

  // const shareUrl = "https://developmentconcerncht.org/about/mission-and-vision";

  return (
    <>
      <Navbar />
      {/* <TranslateButton /> */}

      <div className="vision_mission_section">
        <div className="header_image">
          <p>Home | About</p>
          <h2>Mission & Vision</h2>
        </div>

        {/* Header Background Part Start */}
        {/* <div className="header_background">
          <div className="container wrapper">
            <h2> Mission and Vision </h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div> */}
        {/* Header Background Part End */}

        <div className="container">

          <h1>Mission and Vision</h1>

          <div className="content_wrapper">
            <div className="mission">
              <Fade bottom duration={2000}>
                <div>
                  <h3>Our Mission</h3>
                  <p>
                    Empower underprivileged communities to generate income, improve livelihoods, eradicate poverty, and promote sustainable development and environmental preservation through inclusive, community-driven initiatives.
                  </p>
                </div>
              </Fade>

              {/* <Zoom duration={2000}>
                <div className="mission_right_image">
                  <img src={missinImage} alt="" />
                </div>
              </Zoom> */}
            </div>

            <div className="vision">
              {/* <Zoom duration={2000}>
                <div>
                  <img src={visionImage} alt="" />
                </div>
              </Zoom> */}

              <Fade bottom duration={2000}>
                <div>
                  <h3>Our Vision</h3>
                  <div className="single_vision">
                    <p>
                      To build a just and inclusive society where underprivileged communities enjoy sustained development, access to basic needs, and full realization of their human rights through effective development initiatives.
                    </p>
                  </div>
                </div>
              </Fade>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MissionAndVision;
